
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faqJDANrDHeyRssSL7Gtsa_45N5ACkk984KcSAjMLKBTA1WgMeta } from "/codebuild/output/src570282337/src/src/pages/faq.vue?macro=true";
import { default as menuf018IN_ikwRgkr8PjcVCkQvW73wdv0GQDwdRzvlZGiUMeta } from "/codebuild/output/src570282337/src/src/pages/menu.vue?macro=true";
import { default as index6Wa_45A4fJO3j_45FQzl7G_WHZwi4WNCmRsAwgpYBlp_71EMeta } from "/codebuild/output/src570282337/src/src/pages/index.vue?macro=true";
import { default as contactVejt1610Mq9tclAl3un4MPEXSRYXajUX_455Qc_xVc5U0Meta } from "/codebuild/output/src570282337/src/src/pages/contact.vue?macro=true";
import { default as tutorialmlwwfZv43Pmh9SuxVvLBx0Sp7hAcqxC3ZhY2GJPEh4cMeta } from "/codebuild/output/src570282337/src/src/pages/tutorial.vue?macro=true";
import { default as agreementZeYe11obcuTMl_qmGkJdSWtpV2taRft239EyRjLi25sMeta } from "/codebuild/output/src570282337/src/src/pages/agreement.vue?macro=true";
import { default as about_45passqMjQ4nl3KghDfJ96klteacrnTNVZDcDyZKkuyyQ4OTcMeta } from "/codebuild/output/src570282337/src/src/pages/about-pass.vue?macro=true";
import { default as index27jCMeMA_r7I38xrtZZzjq44KrwPc3W1keDOW8jJ4T0Meta } from "/codebuild/output/src570282337/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93KAXpCK1z6_fRFfee8yOsHn4_mpv_Q_45ThIGl18HkEwloMeta } from "/codebuild/output/src570282337/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceBiIaVvtoNOFVGrh4rNlwXRKeTa5EXKxRyGJKCgrb2FUMeta } from "/codebuild/output/src570282337/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93NZKAKHHkcgLUBor_45g3OJ9Uv2Df_45Wl1T6TRW8pC3nJRAMeta } from "/codebuild/output/src570282337/src/src/pages/notice/[id].vue?macro=true";
import { default as index0X5bd8uIa8nEE7iLBQrOU_gEtP2HcKWEx51IUNwUT4UMeta } from "/codebuild/output/src570282337/src/src/pages/coupon/index.vue?macro=true";
import { default as indexmA9OrVo9FBi_z_45lEA4VEcL2BKD1GgTj6MGE_458kSIHlQMeta } from "/codebuild/output/src570282337/src/src/pages/mypage/index.vue?macro=true";
import { default as indexyFZ5bLpkUE9aUnJOyReFv9b2Lvz21Z6avv0CZsJZ3y4Meta } from "/codebuild/output/src570282337/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93PUv0N4bpr2gKgLRu5toxgPkuqZ_45ipKZLZnzYJn5ytwgMeta } from "/codebuild/output/src570282337/src/src/pages/parking/[id].vue?macro=true";
import { default as indexVPDJ4N8yTliES4ZeLdn5lhkVBn4Lbh2LHSH4zsF7qFQMeta } from "/codebuild/output/src570282337/src/src/pages/history/index.vue?macro=true";
import { default as indexmFG7oAOHd0nuUZOKJVa5kOAESulhUdEagz9oppZEMBEMeta } from "/codebuild/output/src570282337/src/src/pages/monthly/index.vue?macro=true";
import { default as indexRtb72yFp_45hQYQh2lSPyKwH7qOwysWmv4_45a3Nxz7ad9gMeta } from "/codebuild/output/src570282337/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexbcHniOOeYI972UzGyHwHnmTkjwS_tN8HQyn7qoOJLLMMeta } from "/codebuild/output/src570282337/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavi15FbAM9zujs4RXv2arEkV1atRNHQHCeHIvJpQ1n5ukcMeta } from "/codebuild/output/src570282337/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editjnJucvu0X2oNFuz7JAcCZHHiK1cF0qxmCnVXcBylC4QMeta } from "/codebuild/output/src570282337/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementLVlDSNkDny3LhvO_45_lPiib3xa2V_666pnn6K34mgyQMMeta } from "/codebuild/output/src570282337/src/src/pages/pass-agreement.vue?macro=true";
import { default as index4r73tObgumgdfHeLRUSwcRdoK4G1Wzxm3mLf3R4WqToMeta } from "/codebuild/output/src570282337/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dDvj_s1pObF1djlYJ4Bm3HXLYwb7sz0aDSRK_458SQaZDcMeta } from "/codebuild/output/src570282337/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirm7XHmeJjltGz3w8Q1hbFJ19fyjQ1OIdAKRgtIImfk83YMeta } from "/codebuild/output/src570282337/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexvLiOYGMdNJ6dIfYxOOa2_45jFsoifkux4bh_0HJSEwyiEMeta } from "/codebuild/output/src570282337/src/src/pages/card/create/index.vue?macro=true";
import { default as indexYY_45V_45W64QOPxcYTbt6ZGxa26fUReR5AtUMz9EV9aYiAMeta } from "/codebuild/output/src570282337/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmb_7ot40pUl3nOau_r2WvsJ8xRJbqWT0lC5MgM_45BIE6wMeta } from "/codebuild/output/src570282337/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirm8OPOkd6A_456s8q_45XDZaQ0eBNq4dIvvyVAVPnafrknvCMMeta } from "/codebuild/output/src570282337/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeFfoIC9aGsOLq5BlcapUrl1giEoGuaUuJMCTPZdtTR7UMeta } from "/codebuild/output/src570282337/src/src/pages/membership/complete.vue?macro=true";
import { default as registernlM28hv4NwGhj8Ne1k8UrV1GgKDbsZJlSeyTE_UWlckMeta } from "/codebuild/output/src570282337/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93s4TGn_gERY8frPTHm_7U2rvQjg4cpSRW0lQ0vSPMykMMeta } from "/codebuild/output/src570282337/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmiWL6CWtY_45L0FYoVT6r6p6OVDGVGTChjZtc8IPyv_kRwMeta } from "/codebuild/output/src570282337/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93ChlP58k4mtXlqw5TH8z85QzTsv89kmjT7FIk5oxSHQEMeta } from "/codebuild/output/src570282337/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexjxYK4RxHhQ_45VF88gQJaag_1docr_R_X_45vH4cEFE3gpIMeta } from "/codebuild/output/src570282337/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeqUGo9L5XsmMWYmH00ClxaQjDqTFuXSS0Jm8C5NY6i_0Meta } from "/codebuild/output/src570282337/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeuko2bCUtwjRa6kO7b7EUlt8rC4qU26IWY_45iGzTDVF0MMeta } from "/codebuild/output/src570282337/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completekyQL2_45gYjHsprFgLRHVudaq6fxfUS7fxeLghjqkXjZsMeta } from "/codebuild/output/src570282337/src/src/pages/contact-form/complete.vue?macro=true";
import { default as register1vzPqtFBcn81Y202Lchkc8Y2Xo_DbczIJvEyMgh41lUMeta } from "/codebuild/output/src570282337/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeaqKejjZXecwRJPkwBlbo3_bZF2Rk4UR8LFX23iID_45p4Meta } from "/codebuild/output/src570282337/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexmgu3CuKxwttT6MhrVPEKZsuxEwVX1MAE2x8RFJZcNZcMeta } from "/codebuild/output/src570282337/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmIpAum2hin6tcOPGIyl8ov4Mod5uT69ItMOg15hhtHvUMeta } from "/codebuild/output/src570282337/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeaQC_pA5UQ4H5RKM1uaUQQ5PnbW8TQGpc5vMHC_45fyjsIMeta } from "/codebuild/output/src570282337/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexSea9a6_kXdLONy3qMRdB4JT7_45tK_KHt887oGD1Qj6jwMeta } from "/codebuild/output/src570282337/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93lHFgRYQqQDF4xGVfBsXVKq4tJnnOkTYVyZhh3RwK9PgMeta } from "/codebuild/output/src570282337/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeODPbS0NFP3NPYEOKE_45OqUFKasTRETeTnnt0DOgHIBsAMeta } from "/codebuild/output/src570282337/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45alias6UIK3DmmqXPgLSbziZh3nBb4CSJyx23BgNq3dOAkn8EMeta } from "/codebuild/output/src570282337/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleSFMtIegkyBfSm9w3j9aYRhC5xlFm5mo5u98vS7woyOgMeta } from "/codebuild/output/src570282337/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45email5T79PDzcdQ_LTE2FGy2Nkidm_wjXpkEbaJatjRGfVLMMeta } from "/codebuild/output/src570282337/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirma9w8vF2JboSBRbObq4Euu2_45iOOXJUyyZpgIzJJrbZWAMeta } from "/codebuild/output/src570282337/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentHuVqr2ptwRwjJWfzGpYf5hjKVtsLWcN2yUOkeyqOpr8Meta } from "/codebuild/output/src570282337/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmAtlYpj4U3kFydsvkPWc37mfZwdF_45Nf309SZehu4HiIMMeta } from "/codebuild/output/src570282337/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate1zxdI0OvnejDe2Zf2tKfxQ4P_iPPy6QX_45UcOiTePGGEMeta } from "/codebuild/output/src570282337/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completetj_45A_45Oa1_45Br7SOy043t1EUsICtdoUVObIudyRoJTFhIMeta } from "/codebuild/output/src570282337/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codevj1pD8uadlAfRfiRCUtaEx_JsxLamq14_45IQ_45kyyjoA8Meta } from "/codebuild/output/src570282337/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordJW0ix2ZqXfASpjCj6hFpMHE2FJTMrBJRXbFsNX_45Ie2wMeta } from "/codebuild/output/src570282337/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasdl1rRK1ELl5E6nsxWtxIlsUJkqhBaLCU9bB1SGlUStcMeta } from "/codebuild/output/src570282337/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerg5ZaWB3n1fYLJGgTkeXOcrAq5xdvgXI03IWYCHq2ZB8Meta } from "/codebuild/output/src570282337/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeeJTF9a2ujGIyBp4640hLZhes4olfsdxPEJg_4Z4wikMMeta } from "/codebuild/output/src570282337/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index3SKVBSbBE1Tecp8__9fK10aFtiBVakF0PuoDNhc_45uFgMeta } from "/codebuild/output/src570282337/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexpgz1LAHVpGgCfhzEcbCsD1XpYzYdZJXHPRVzcUfLzyoMeta } from "/codebuild/output/src570282337/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexNwnuRq6LpGsKU8nG4nYHe6ZS3RSfom_45PZ3qBoFPrxE4Meta } from "/codebuild/output/src570282337/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexjqO2igI2krQp6s6Y_dy4PzUrIf1sU3Rgy0MNOh_8cysMeta } from "/codebuild/output/src570282337/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatecoo6cPLGMu60NVfoY_45tE1uXGeSRgNxmQTPrIRIi1sAgMeta } from "/codebuild/output/src570282337/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeepdoXt22XWNbACkuzKbSydyAEqGgxzXTUIigdCaON0IMeta } from "/codebuild/output/src570282337/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmFwisaKNy_45l7rx9TMANS9EoNcdhSIXkeWKv7nTYi6a78Meta } from "/codebuild/output/src570282337/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexHwfJQMDIqu1LcWqHFJN360IZmT8aYhNMYm5JmZnzGDkMeta } from "/codebuild/output/src570282337/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completegl3crX0PzXGn3aPLPpARyuEv1yj1LU7JM7kLpflKeGIMeta } from "/codebuild/output/src570282337/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update_45k3PgBeUsmDwOEelULKC5t_RPMKEGY6YglQ2lakR06AMeta } from "/codebuild/output/src570282337/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexkNvnyzF0dE0BDC4yAUZJaEJYNfZLwvHJDEjM53s3zhgMeta } from "/codebuild/output/src570282337/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexzEtJ_45qGXZO_45EwCLKZytrDiHdNafmkTb1TFiMLJAfS40Meta } from "/codebuild/output/src570282337/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeyLJ12_jJcFAsg6qqohj8BQfj8UNreITrKRwg9qZ6okoMeta } from "/codebuild/output/src570282337/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexwmC0MBATlUg5dV6T9L3dRg3A9NdCUzfv_qW5kSq_xScMeta } from "/codebuild/output/src570282337/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codepPGpRAM1RKo6RceRwikN7lwK9vEdHFbClCM_SGiDHboMeta } from "/codebuild/output/src570282337/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexIuJoXzHXQFeyAbktF5zfwY90hBHKk1iHlxWRYQIAMwQMeta } from "/codebuild/output/src570282337/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexVTdhAb6BjbqHURCUQ6YKHLkp_DtUGQ_hMngf9WdnufYMeta } from "/codebuild/output/src570282337/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexE58EjinINfcDONGgRqR9BcJui1Cks34uWXNj2MI3pooMeta } from "/codebuild/output/src570282337/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateJ0WyLdJa8uUPmqt9BaI8YCpuTRaLPkBJq1ONqGs4eXgMeta } from "/codebuild/output/src570282337/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmDVrCBshGHYXtFT5vNpXYBOZwNr15I5_45q3FOFN1vb3g4Meta } from "/codebuild/output/src570282337/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src570282337/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuf018IN_ikwRgkr8PjcVCkQvW73wdv0GQDwdRzvlZGiUMeta || {},
    component: () => import("/codebuild/output/src570282337/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index6Wa_45A4fJO3j_45FQzl7G_WHZwi4WNCmRsAwgpYBlp_71EMeta || {},
    component: () => import("/codebuild/output/src570282337/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src570282337/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src570282337/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src570282337/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src570282337/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src570282337/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src570282337/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src570282337/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src570282337/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index0X5bd8uIa8nEE7iLBQrOU_gEtP2HcKWEx51IUNwUT4UMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src570282337/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src570282337/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src570282337/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src570282337/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexVPDJ4N8yTliES4ZeLdn5lhkVBn4Lbh2LHSH4zsF7qFQMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src570282337/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src570282337/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexRtb72yFp_45hQYQh2lSPyKwH7qOwysWmv4_45a3Nxz7ad9gMeta || {},
    component: () => import("/codebuild/output/src570282337/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexbcHniOOeYI972UzGyHwHnmTkjwS_tN8HQyn7qoOJLLMMeta || {},
    component: () => import("/codebuild/output/src570282337/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src570282337/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src570282337/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src570282337/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src570282337/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src570282337/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src570282337/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexvLiOYGMdNJ6dIfYxOOa2_45jFsoifkux4bh_0HJSEwyiEMeta || {},
    component: () => import("/codebuild/output/src570282337/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src570282337/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmb_7ot40pUl3nOau_r2WvsJ8xRJbqWT0lC5MgM_45BIE6wMeta || {},
    component: () => import("/codebuild/output/src570282337/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirm8OPOkd6A_456s8q_45XDZaQ0eBNq4dIvvyVAVPnafrknvCMMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src570282337/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeFfoIC9aGsOLq5BlcapUrl1giEoGuaUuJMCTPZdtTR7UMeta || {},
    component: () => import("/codebuild/output/src570282337/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registernlM28hv4NwGhj8Ne1k8UrV1GgKDbsZJlSeyTE_UWlckMeta || {},
    component: () => import("/codebuild/output/src570282337/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src570282337/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmiWL6CWtY_45L0FYoVT6r6p6OVDGVGTChjZtc8IPyv_kRwMeta || {},
    component: () => import("/codebuild/output/src570282337/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src570282337/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src570282337/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeqUGo9L5XsmMWYmH00ClxaQjDqTFuXSS0Jm8C5NY6i_0Meta || {},
    component: () => import("/codebuild/output/src570282337/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeuko2bCUtwjRa6kO7b7EUlt8rC4qU26IWY_45iGzTDVF0MMeta || {},
    component: () => import("/codebuild/output/src570282337/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completekyQL2_45gYjHsprFgLRHVudaq6fxfUS7fxeLghjqkXjZsMeta || {},
    component: () => import("/codebuild/output/src570282337/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: register1vzPqtFBcn81Y202Lchkc8Y2Xo_DbczIJvEyMgh41lUMeta || {},
    component: () => import("/codebuild/output/src570282337/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src570282337/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src570282337/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmIpAum2hin6tcOPGIyl8ov4Mod5uT69ItMOg15hhtHvUMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src570282337/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeaQC_pA5UQ4H5RKM1uaUQQ5PnbW8TQGpc5vMHC_45fyjsIMeta || {},
    component: () => import("/codebuild/output/src570282337/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexSea9a6_kXdLONy3qMRdB4JT7_45tK_KHt887oGD1Qj6jwMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src570282337/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src570282337/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeODPbS0NFP3NPYEOKE_45OqUFKasTRETeTnnt0DOgHIBsAMeta || {},
    component: () => import("/codebuild/output/src570282337/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src570282337/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleSFMtIegkyBfSm9w3j9aYRhC5xlFm5mo5u98vS7woyOgMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src570282337/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45email5T79PDzcdQ_LTE2FGy2Nkidm_wjXpkEbaJatjRGfVLMMeta || {},
    component: () => import("/codebuild/output/src570282337/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirma9w8vF2JboSBRbObq4Euu2_45iOOXJUyyZpgIzJJrbZWAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src570282337/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentHuVqr2ptwRwjJWfzGpYf5hjKVtsLWcN2yUOkeyqOpr8Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src570282337/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmAtlYpj4U3kFydsvkPWc37mfZwdF_45Nf309SZehu4HiIMMeta || {},
    component: () => import("/codebuild/output/src570282337/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src570282337/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completetj_45A_45Oa1_45Br7SOy043t1EUsICtdoUVObIudyRoJTFhIMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src570282337/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codevj1pD8uadlAfRfiRCUtaEx_JsxLamq14_45IQ_45kyyjoA8Meta || {},
    component: () => import("/codebuild/output/src570282337/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordJW0ix2ZqXfASpjCj6hFpMHE2FJTMrBJRXbFsNX_45Ie2wMeta || {},
    component: () => import("/codebuild/output/src570282337/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src570282337/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerg5ZaWB3n1fYLJGgTkeXOcrAq5xdvgXI03IWYCHq2ZB8Meta || {},
    component: () => import("/codebuild/output/src570282337/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeeJTF9a2ujGIyBp4640hLZhes4olfsdxPEJg_4Z4wikMMeta || {},
    component: () => import("/codebuild/output/src570282337/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src570282337/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src570282337/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src570282337/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src570282337/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src570282337/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src570282337/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src570282337/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src570282337/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src570282337/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src570282337/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src570282337/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src570282337/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src570282337/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src570282337/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src570282337/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src570282337/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src570282337/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src570282337/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src570282337/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src570282337/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]